/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { AlertDto } from './alertDto';

export interface AlertsResponseDto {
  /** Array of alerts */
  alerts: AlertDto[];
  /** Total number of alerts */
  total: number;
}
